const $ = require('jquery');
const select = $('#avia_4_1')
const options = $('#avia_4_1 option')
const priceBlock2 = $('#pro_price2')
const perValue2 = $('#pervalue2')
const priceBlock3 = $('#pro_price3')
const perValue3 = $('#pervalue3')
const priceDomBlock2 = document.getElementById('pro_price2')

export const changeDomPrice = (mode, price) => {
  let priceTable2, perTime2, priceTable3, perTime3;
  priceDomBlock2.setAttribute('data-mode', mode)
  priceTable2 = price
  priceTable3 = price * 11
  perTime2 = 'month'
  perTime3 = 'year'

  priceBlock2.html(priceTable2)
  perValue2.html(perTime2)
  priceBlock3.html(priceTable3)
  perValue3.html(perTime3)
}

export const changeDomSelect = (value) => {
  options.each((index,value) => $(value).attr('selected', false))
  $(options[value]).attr('selected', true)
  $(select).change();
}

export const changeDomTransferLimit = (volume, transferLimit) => {
  const volumeString = `${volume} GB Storage`
  $('.select-price2 button .filter-option').html(volumeString)
  $('.select-price2 button').attr('title', volumeString)
  $('#pro_data2').html(transferLimit)
}
